import React from 'react';
import Section from './section';
import SimpleReportTable, { SimpleReportTableColumn } from './simpleReportTable';
import styles from '../index.module.scss';

interface iLastWeekHighRiskVehicleStatusProps {
    data?: any[]
}
// 上周高风险车辆本周运行情况模块
const LastWeekHighRiskVehicleStatus = (props: iLastWeekHighRiskVehicleStatusProps) => {
    const { data = [] } = props;
    const getRiskChangeClassName = (value?: string) => {
        if (!value) return undefined;
        if (value.includes('->高')) return styles.riskChangeHigh;
        if (value.includes('->中')) return styles.riskChangeMedium;
        if (value.includes('->低')) return styles.riskChangeLow;
        return undefined;
    };

    const columns: SimpleReportTableColumn[] = [
        { title: '车辆', dataIndex: '车辆', key: 'vehicle' },
        { title: '车辆类型', dataIndex: '车辆类型', key: 'vehicleType' },
        { title: '车队', dataIndex: '车队', key: 'fleet' },
        { title: '安全指数评分', dataIndex: '安全指数评分', key: 'safetyScore' },
        {
            title: '风险变化情况',
            dataIndex: '风险变化情况',
            key: 'riskChangeStatus',
            render: (value: string) => <span className={getRiskChangeClassName(value)}>{value || '--'}</span>
        },
        { title: '管控建议', dataIndex: '风险情况', key: 'controlSuggestion' },
    ];

    return (
        <Section title="四、上周高风险车辆本周运行情况">
            <SimpleReportTable
                columns={columns}
                dataSource={data}
                rowKey={(record, index) => record?.车辆 || index}
                scrollX
                emptyText="暂无上周高风险车辆本周运行数据"
            />
        </Section>
    );
};

export default LastWeekHighRiskVehicleStatus;
